<ul class="breadcrumb ms-4 ps-0">
  <li class="breadcrumb-item"><a class="roboto-medium">Home</a></li>
  <li class="breadcrumb-item"><a class="roboto-medium">Planning</a></li>
  <li class="breadcrumb-item"><a class="roboto-medium">Cost Planning</a></li>
  <li *ngFor="let breadcrumb of breadcrumbs; let i = index;" class="breadcrumb-item">
    <a class="current roboto-medium">{{breadcrumb.label}}</a>
  </li>
</ul>